import React, { useRef } from "react";
import { images } from "../Data";

const VideoCard = ({ video, img, price, longTitle }) => {
  const videoRef = useRef(null);

  const handleMouseEnter = () => {
    videoRef.current?.play();
  };

  const handleMouseLeave = () => {
    videoRef.current?.pause();
    videoRef.current.currentTime = 0; // Optional: Reset video to start
  };

  return (
    <div className="link rounded-2xl border border-[#ddd] overflow-hidden">
      <div className="max-h-[700px]">
        <video
          ref={videoRef}
          muted
          width="100%"
          height="100%"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <source src={video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="flex py-4 px-2 items-center gap-4">
        <div className="max-w-[70px]">
          <object
            data={img}
            type="image/jpeg"
            className="w-full object-cover h-full"
          >
            <img
              src={images.fallbackimg}
              alt={longTitle}
              className="w-full object-cover h-full"
            />
          </object>
        </div>
        <div className="flex gap-2 flex-col">
          <h2 className="font-bold text-xl">{price}</h2>
          <p className="text-sm">{longTitle}</p>
        </div>
      </div>
    </div>
  );
};

export default VideoCard;
